import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { Observable } from "rxjs";

declare var $ :any;

@Component({
  selector: 'app-redirecionamento',
  templateUrl: './redirecionamento.component.html',
  styleUrls: ['./redirecionamento.component.css']
})
export class RedirecionamentoComponent extends AbstractComponent implements OnInit {

  tempo: number;

  constructor(
    private router: Router,
    private sessaoService: SessaoService) {
    super(sessaoService);

    this.tempo = this.sessao.configuracaoVisual.nuQtdeTempoRedir;
    if(this.tempo == null){
      this.tempo = 2;
    }
  }

  ngOnInit() {
    // Resolucao
    var WindowsSize=function(){
      // Toggle menu abrir conforme a resolucao
      var h=$(window).height(),
          w=$(window).width();

      // Conteudo altura
      $(".pageFull").css('height', h);
    };
    $(document).ready(WindowsSize);
    $(window).resize(WindowsSize);

    // Parceiros
    if(this.sessaoService.sessao.autenticado.parceiro.cdParceiro !== 1){
      $( ".logoBradesco" ).attr( "style", "display: inline-block !important" );
    }
    $( ".imgLogin" ).attr( "src", "data:image/png;base64," + this.sessaoService.sessao.configuracaoVisual.imgLogoIdentificacao );
    $( ".imgLogin" ).attr( "title", this.sessaoService.sessao.configuracaoVisual.dsLogo );

    // Efetua a contagem regressiva
    Observable.interval(1000)
      .takeWhile(() => this.stopCondition())
      .subscribe(i => {
          this.tempo -= 1;
    });
  }

  /**
   * Verifica se o tempo chegou em zero.
   */
  stopCondition = (): boolean => {
    if(this.tempo != 0){
      return true;
    }
    else {
      sessionStorage.clear();
      this.sessaoService.sessao.logado = false;
      window.location.href = this.sessao.configuracaoVisual.urlSiteDestinoRedir;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/redirecionamento/redirecionamento.component.ts